import { Component, HostListener, Inject, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { interval } from 'rxjs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { MessageService } from 'src/app/@shared/message/message.service';

@Component({
    selector: 'app-sport-detail',
    templateUrl: './sport-detail.component.html',
    styleUrls: ['./sport-detail.component.css']
})
export class SportDetailComponent extends BaseClass<any> implements OnInit {

    @ViewChild('betSlipModal', { static: false }) betSlipModal?: ModalDirective;

    public data: any;
    public id: any = '';
    public mId: any = '';
    public multiMarketIds: any[] = [];
    public raceTimer: any;
    public exposLisDis: any = {};
    public fancyTab: any[] = [];
    public marketsReq: any[] = [];
    public marketIds: any[] = [];
    public token: any = '';
    public newOddsEnable: boolean = false;
    public fLineMrk: boolean = false;
    public fFancyMrk: boolean = false;
    public allFancy: any[] = [];
    public oodsList: any[] = [];
    public oddsLisDis: any = {};
    public betSlipData: any = {};
    public nextExpoList: any = {};
    public scoreHtml: any = '';
    public iframeURL: any = '';
    modalRef?: BsModalRef;
    public isCollapsed = {
        tv: {
            desktop: true,
            mobile: true
        }
    }
    scrolled: boolean = false;
    public userDataGot: boolean = false;
    public _pusher!: PusherService;

    @HostListener("window:scroll", [])
    onWindowScroll() {
        this.scrolled = window.scrollY > 78;
    }

    constructor(
        public service: WebserviceService,
        @Inject(DOCUMENT) public document: Document,
        private actRoute: ActivatedRoute,
        public _shared: SharedService,
        private injector: Injector,
        public router: Router,
        public _common: CommonService,
        protected http: HttpClient,
        private modalService: BsModalService,
        public _message: MessageService,
    ) {
        super();
        this.constructorCallData();
    }

    constructorCallData() {

        this.id = this.actRoute.snapshot.paramMap.get('id');
        this.mId = this.actRoute.snapshot.paramMap.get('mId');

        //emit value in sequence every given second\
        const sub1 = interval(this.env.pollers.oddsData).subscribe(val => {
            if (this.webSocketUrl != '') {
                if (this.newOddsEnable == true) {
                    this.getOddsNew(this.marketsReq, this.data, true);
                } else {
                    this.getOdds(this.marketsReq, this.data, true);
                }
            }
        });
        this.subs.push(sub1);

        const sub2 = interval(this.env.pollers.scoresData).subscribe(val => {
            if (this.webSocketUrl != '')
                this.scoreData();
        });
        this.subs.push(sub2);

        this.callPusherChannels();
    }

    callPusherChannels() {
        if (this.isLogin()) {
            this.userDataGot = true;
            this._pusher = this.injector.get<PusherService>(PusherService);

            const sub3 = this._pusher.eventUpdate(this.actRoute.snapshot.paramMap.get('id')).subscribe(res => {
                this.updateEvenByPusher(res);

            });
            this.subs.push(sub3);

            const sub4 = this._pusher.exposerUpdate(this.actRoute.snapshot.paramMap.get('id')).subscribe(res => {
                if (res) {
                    this._shared.emitUpdateExpoPusher(res);
                    this.setExposeData(this.data, [res.exposes]);
                }
            });
            this.subs.push(sub4);
        }
    }

    ngOnInit(): void {
        this.rout();
        this.getData();
        if (this.webSocketUrl != '')
            this.scoreData();
    }

    rout() {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                if (this.id != this.actRoute.snapshot.paramMap.get('id') || (this.mId != null && this.mId != this.actRoute.snapshot.paramMap.get('mId'))) {
                    this.id = this.actRoute.snapshot.paramMap.get('id');
                    this.mId = this.actRoute.snapshot.paramMap.get('mId');
                    this.marketsReq = [];
                    this.oodsList = [];
                    this.data = undefined;
                    this.getData();
                }
            }
        })
    }

    getServices(): IbaseService<any> {
        return this.service;
    }

    getData() {
        this.isLoad = true;
        let api = (this.isLogin()) ? this.api.eventDetail : this.api.eventDetailG;
        this.getServices().Post(`${this.env.baseUrl + api}/${this.actRoute.snapshot.paramMap.get('id')}`, '').subscribe(
            (res) => {
                if (res && res.status == true) {
                    this.commonLogics(res);
                } else {
                }
            },
            (err) => {
                console.log(err);
            });
    }

    getEventDetailOnly() {
        if (this.data?.event) {
            this.isLoad = true;
            this.getServices().Post(`${this.env.baseUrl + this.api.eventDetailOnly}/${this.actRoute.snapshot.paramMap.get('id')}`, '').subscribe(
                (res) => {
                    if (res && res.status == true) {
                        this.commonLogics(res, 'detailOnly');
                    }
                },
                (err) => {
                    console.log(err);
                });
        } else {
            console.log('event detail only prevented due to no data.event found')
        }
    }

    commonLogics(res: any, keyTxt: any = '') {
        this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
        this.setLocalItem('ws', this.webSocketUrl, false);

        res.data.event.fancy = res.data.event.fancy == null ? [] : res.data.event.fancy;
        res.data.event.book_makers = res.data.event.book_makers == null ? [] : res.data.event.book_makers;
        res.data.event.markets = res.data.event.markets == null ? [] : res.data.event.markets;

        this.multiMarketIds = [];
        if (res?.data?.multi_markets)
            res?.data?.multi_markets.forEach((element: any) => {
                this.multiMarketIds.push(element.market_id)
            });

        res.data.event.markets.forEach((element: any) => {
            // Race time update with related race-market time
            if (this.mId && this.mId != null && element.market_id == this.mId) {
                res.data.event.event['market_start_time'] = element.market_start_time;

                // countDown timer for racing data
                let mktDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date(element.market_start_time))
                let currentDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date())
                element['bet_start_in'] = setInterval(() => {
                    this.timeBetweenDates(mktDate, currentDate);
                }, 1000);
                element['bet_open'] = (mktDate.getTime() <= new Date().getTime()) ? true : false;
            }

            element.runners.forEach((rData: any) => {
                rData.meta_data = JSON.parse(rData.meta_data);
            });
        });

        // detail API call
        if (keyTxt == '') {
            this.token = res.data.token;
            this.multiMarketIds = [];
            if (res?.data?.multi_markets) {
                res?.data?.multi_markets.forEach((element: any) => {
                    this.multiMarketIds.push(element.market_id)
                });
            }
        }

        if (this.data) {
            this.data = this.compareAndSetEventData(this.data, res.data);
        } else {
            // detailOnly API call
            if (keyTxt == 'detailOnly') {
                this.data = {};
                this.data['event'] = res.data?.event;
            } else {
                this.data = res.data;
            }
        }

        this.fancyTabLog(res);
        this.isLoad = false;

        if (res?.data?.multi_markets) {
            res?.data?.multi_markets.forEach((element: any) => {
                this.multiMarketIds.push(element.market_id)
            });
        }

        this.data = this.setDateFormate(this.data);
        this.marketsReq = this._common.createMarketIdList(this.data.event) as any;
        this.marketIds = this._common.createMarketIds(this.data.event) as any;
        this._shared.nextMessage(this.data?.message);
        if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.getOddsNew(this.marketsReq, this.data, true);
        } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, this.data, true);
        }

        if (this.isLogin()) {
            this.getExposure(this.marketsReq, this.data);
        }
    }

    timeBetweenDates(toDate: Date, currentDate: Date) {
        var dateEntered = toDate;
        var now = new Date();
        var difference = dateEntered.getTime() - now.getTime();
        let str = '';
        if (difference <= 0) {
            // Timer done
            clearInterval(this.raceTimer);
        } else {
            var seconds = Math.floor(difference / 1000);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            var days = Math.floor(hours / 24);
            hours %= 24;
            minutes %= 60;
            seconds %= 60;
            str = `Bet Starts in (${days != 0 ? days + ':' : ''}${hours}:${minutes}:${seconds})`
        }
        this.raceTimer = (toDate.getTime() == currentDate.getTime()) ? '' : str;
    }

    compareAndSetEventData(oldItems: any, resItems: any) {
        Object.keys(resItems.event).forEach(key => {
            resItems = this.setExposeData(resItems, oldItems?.exposes);
            oldItems.event.event = resItems?.event?.event;

            if (typeof (resItems.event[key]) == 'object' && resItems.event[key]?.market_id && oldItems.event[key]?.market_id) {
                oldItems.event[key] = resItems.event[key];
            } else if (Array.isArray(resItems.event[key])) {
                oldItems.event[key] = resItems.event[key];
            }
        });
        return oldItems;
    }

    getExposure(req: any, items: any) {
        this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
            (res) => {
                if (res && res.status == true) {
                    res = res.data.exposes;
                    res = this.string_to_JSON(res);
                    items = this.setExposeData(items, res);
                    this.data = items;
                    this.isLoad = false;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    tempExpo: any[] = [];
    setExposeData(items: any, res: any) {

        if (items && res) {
            // average expose
            res.forEach((element: any) => {
                element.forEach((expo: any, i: any) => {
                    this.tempExpo.forEach((tEle: any) => {
                        if (tEle && tEle?.market_id == expo?.market_id && tEle[`${expo?.selection_id}_expose`]) {
                            if (tEle?.market_id[0] == '9') {
                                expo.expose = Number(tEle[`${expo?.selection_id}_expose`]);
                            } else {
                                expo.expose += Number(tEle[`${expo?.selection_id}_expose`]);
                            }
                        }
                    });
                });
            });
            res.forEach((element: any) => {
                element.forEach((expo: any, i: any) => {
                    if (element.length == 2) {
                        if (i == 0) {
                            let avg_value: any;
                            avg_value = Math.abs((parseFloat(element[0].expose) / parseFloat(element[1].expose))).toFixed(2);
                            if (!isFinite(avg_value)) {
                                element[i]["average"] = '';
                            } else {
                                element[i]["average"] = ' (' + avg_value + ')';
                            }
                        } else {
                            let avg_value: any;
                            avg_value = Math.abs((parseFloat(element[1].expose) / parseFloat(element[0].expose))).toFixed(2);
                            if (!isFinite(avg_value)) {
                                element[i]["average"] = '';
                            } else {
                                element[i]["average"] = ' (' + avg_value + ')';
                            }
                        }
                    }
                });
            });
            res.forEach((element: any) => {
                let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
                this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = temp;
            });
        }
        return items;
    }

    fancyTabLog(res: any) {
        this.fancyTab = [];
        res.data.fancy_tab = (typeof res.data.fancy_tab == 'string') ? JSON.parse(res.data.fancy_tab) : res.data.fancy_tab;
        this.fLineMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type == 'LINE') : false; this.data = this.setDateFormate(this.data);
        this.fFancyMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type != 'LINE') : false; this.data = this.setDateFormate(this.data);

        // set all fancy Data
        let all: any[] = [];
        let others: any[] = [];
        res.data.event.fancy.forEach((element: any) => {
            all.push(element.sort_priority);
        });
        const uniqueSet = new Set(all);
        all = [...uniqueSet];
        this.allFancy = all;
        this.fancyTab.push({ name: 'all', value: all });

        // set fancy Other
        others = all;
        try {
            res.data.fancy_tab = JSON.parse(res.data.fancy_tab);
        } catch (error) {
        }
        
        Object.keys(res.data.fancy_tab).forEach((key, i) => {
            
            // others = others.filter(val => !res.data.fancy_tab[key].includes(val));
            // if (key.includes('xtra')) {
            //     res.data.fancy_tab[key] = [...res.data.fancy_tab[key], ...others]
            // }
            this.fancyTab.push({ name: key, value: res.data.fancy_tab[key] })
        });
        
    }

    setDateFormate(res: any) {
        res.event.book_makers = (res.event.book_makers != null) ? this.UTC_to_Local_timeZone(res.event.book_makers) : [];
        // res.event.event = (res.event.event != null) ? this.UTC_to_Local_timeZone(res.event.event) : {};
        res.event.fancy = (res.event.fancy != null) ? this.UTC_to_Local_timeZone(res.event.fancy) : [];
        res.event.markets = (res.event.markets != null) ? this.UTC_to_Local_timeZone(res.event.markets) : [];
        res.event.match_odds = (res.event.match_odds != null) ? this.UTC_to_Local_timeZone(res.event.match_odds) : {};
        return res;
    }

    oddsLisDisNew: any = {};
    getOddsNew(req: any, items: any, isDetail: boolean) {
        this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
            (res) => {
                res = this.pipe_string_to_JSON(res);
                let resOdds: any = this._common.arrangeGetMarketNewData(res, items);
                //compare list
                this.oodsList = this._common.compareData(Object.keys(resOdds).map(key => (resOdds[key])), this.oodsList);
                if (this.oddsLisDisNew.length == 0) {
                    this.oddsLisDisNew = resOdds;
                } else {
                    let newOddsLD = resOdds;
                    Object.keys(newOddsLD).forEach(key => {
                        if (Object.keys(this.oddsLisDisNew).includes(key)) {
                            delete this.oddsLisDisNew[key];
                        }
                    });
                    this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
                }
                this.setOdds(this.oddsLisDisNew);
                if (items) {
                    if (items.event.fancy != null)
                        items.event.fancy.sort((a: any, b: any) => parseFloat(a.sort_priority) - parseFloat(b.sort_priority));
                    this.data = items;
                    this.isLoad = false;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    getOdds(req: any, items: any, isDetail: boolean) {
        this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
            (res) => {
                res = this.string_to_JSON(res);
                this.oodsList = this._common.compareData(res, this.oodsList);
                let odds = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));
                this.setOdds(odds);
                if (items) {
                    if (items.event.fancy != null)
                        items.event.fancy.sort((a: any, b: any) => parseFloat(a.sort_priority) - parseFloat(b.sort_priority));
                    this.data = items;
                    this.isLoad = false;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    setOdds(item: any) {
        Object.keys(item).forEach((key: any) => {
            if (item[key].runners) {
                let temp = Object.assign({}, ...item[key].runners.map((elt: any) => ({ [elt.selectionId]: elt })));
                item[key]['cRunners'] = temp;
            }
            if (item[key].book_maker_odds) {
                let temp = Object.assign({}, ...item[key].book_maker_odds.map((elt: any) => ({ [elt.selection_id]: elt })));
                item[key]['cRunners'] = temp;
            }
        });
        this.oddsLisDis = item;
        this.betSlipData['oddsLisDis'] = item;
    }

    scoreData() {
        let tempReq = { "event_id": this.actRoute.snapshot.paramMap.get('id') }
        let req = this._common.JSON_to_URLEncoded(tempReq);
        this.getServices().htmlResponse(`${this.webSocketUrl + this.api.scoreData}`, req).subscribe(
            (res) => {
                this.scoreHtml = res;
            },
            (err) => {
                console.log(err)
            });
    }


    tvData(e: any) {
        if (this.userData?.dr) {
            this._message.errmessage('Please Login with real id')
        } else {

            if (e == 'desktop') {
                this.isCollapsed.tv.desktop = !this.isCollapsed.tv.desktop;
            } else {
                this.isCollapsed.tv.mobile = !this.isCollapsed.tv.mobile;
            }

            let doc = this.document.getElementById(`${e == 'desktop' ? 'tv-block-id-desk' : 'tv-block-id-mob'}`) as HTMLElement;
            if ((this.isCollapsed.tv.desktop == false && e == 'desktop') || (this.isCollapsed.tv.mobile == false && e == 'mobile')) {

                //new change for tv stream
                // if (this.env.host.ftLivetvData.includes('?eventid=')) {
                //     this.iframeURL = `${this.env.host.ftLivetvData}${this.id}`;
                //     doc.innerHTML = `<iframe src="${this.iframeURL}" class="LiveStream-video-col"></iframe>`
                // } else {
                if (this.data.event?.event?.tv_provider == 'ftlive1') {
                    this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
                        let ipAddress = res.ip;
                        this.iframeURL = `${this.env.host.ftLivetvData}${this.data.event?.event?.tv_channel}&ip=${ipAddress}`;
                        // doc.innerHTML = `<iframe src="${this.iframeURL}" class="LiveStream-video-col"></iframe>`
                    });
                } else if (this.data.event?.event?.tv_provider == 'flash') {
                    if (this.data?.tv_domain) {
                        const head = this.document.getElementsByTagName('head')[0];
                        const style = this.document.createElement('link');
                        style.rel = 'stylesheet';
                        style.href = `https://speedcdn.io/flashphoner/css/flashphoner.bundle.min.css`;
                        head.appendChild(style);
                        let inHtml = `<div id="live" class="video" style="overflow: hidden"></div>
<script type="text/javascript" src="https://speedcdn.io/flashphoner/js/flashphoner.bundle.min.js"></script>
<script>
$(document).ready(function () {
init_player('#live', "${this.data.event?.event?.tv_channel}", 'wss://${this.data?.tv_domain}:8443', false, 0);
});
</script>`;
                        this.setInnerHTML(doc, inHtml);
                    } else {
                        doc.innerHTML = `<div>TV Not Available</div>`;
                    }
                } else if (this.data.event?.event?.tv_provider == 'iframe') {
                    this.iframeURL = this.data?.event?.event?.tv_channel;
                    // doc.innerHTML = ` <iframe src="${this.data.event?.event?.tv_channel}" class="LiveStream-video-col"></iframe>`
                }
                // }
            } else if ((this.isCollapsed.tv.desktop == true && e == 'desktop') || (this.isCollapsed.tv.mobile == true && e == 'mobile')) {
                this.iframeURL = '';
                this.isCollapsed.tv.desktop = this.isCollapsed.tv.mobile = true;
            }
        }
    }

    setInnerHTML(elm: any, html: any) {
        elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach((oldScript: any) => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes).forEach((attr: any) => { if (attr.name || attr.value) { newScript.setAttribute(attr.name, attr.value) } });
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    }

    openModal(template: TemplateRef<any>, key: any) {
        let cls = (key == 'book') ? 'exposureModal modal-md' : (key == 'rule') ? 'rulesModaldetail modal-md' : 'modal-md'
        let id = (key == 'bets') ? 'openBets modal-md' : ''
        this.modalRef = this.modalService.show(template,
            Object.assign({}, { class: cls }, { id: id })
        );
    }

    multiMarketUpdate(item: any, key: any) {
        let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/${item?.market_type_id}/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;
        this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
            (res) => {
                if (res && res.status == true) {
                    if (key == 'save') {
                        this.multiMarketIds.push(item?.market_id)
                    } else {
                        const index = this.multiMarketIds.indexOf(item?.market_id);
                        if (index > -1) {
                            this.multiMarketIds.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    this._message.succmessage(res?.data?.message);
                }
            },
            (err) => {
                console.log(err)
            });
    }

    cashOut(e: any, key: any) {
        this.getServices().Get(`${this.env.baseUrl + this.api.cashOut}/${e?.market_id}`).subscribe(
            (res) => {
                if (res && res.status == true) {
                    let ri = '0';
                    if (key == 'book_makers') {
                        e.book_maker_odds.forEach((element: any, i: any) => {
                            if (element.selection_id == res?.data?.runner) {
                                ri = i;
                            }
                        });
                    } else {
                        e.runners.forEach((element: any, i: any) => {
                            if (element.selection_id == res?.data?.runner) {
                                ri = i;
                            }
                        });
                    }

                    let oi = '0';
                    let bet = {};
                    if (key == 'book_makers') {
                        bet = this.oddsLisDis[e?.market_id]?.book_maker_odds[ri];
                        oi = '';
                    } else {
                        oi = (res?.data?.type.includes('l1') || res?.data?.type.includes('b3')) ? '0' : (res?.data?.type.includes('l2') || res?.data?.type.includes('b2')) ? '1' : (res?.data?.type.includes('l3') || res?.data?.type.includes('b1')) ? '2' : ''
                        bet = this.oddsLisDis[e?.market_id]?.runners[ri]?.ex[`${res?.data?.type.includes('l') ? 'availableToLay' : 'availableToBack'}`][oi];
                    }


                    this.openBetPlace(e, this.oddsLisDis[e?.market_id], ri, bet, oi, res?.data?.type, key, res?.data?.bet_amount)


                } else {
                    this._message.errmessage(res?.data?.message);
                }
            },
            (err) => {
                console.log(err);
            });
    }

    openBetPlace(item: any, oodsIitem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string, stake: any = 0) {
        this.betSlipData = {};
        let data = this.betSlipData = this._common.getBetSlipData(item, oodsIitem, i, bet, oi, bkOrLy, key, this.token, stake);
        // console.log(this.betSlipData);
        this.betSlipData['exposLisDis'] = this.exposLisDis;
        if (data && data?.price && data?.price != '0') {
            data['event_name'] = this.data?.event?.event?.name;
            this.betSlipModal?.show();
        } else {
            this.betSlipData = {}
        }
    }

    closeBet(e: any) {
        this.betSlipModal?.hide();
        this.nextExpoList = {}
    }

    updateData(e: any) {
        this.token = e;
        this.betSlipData = {};
    }

    changeExpo(data: any) {
        data?.runners.forEach((element: any) => {
            if (element?.selectionId)
                this.nextExpoList[`${data?.market_id}-${element?.selectionId}`] = element.pnlNext;
            if (element?.selection_id)
                this.nextExpoList[`${data?.market_id}-${element?.selection_id}`] = element.pnlNext;

        });
    }

    openBetPlaceNew(e: any) {
        this.betSlipData = {};
        let data = this.betSlipData = this._common.getBetSlipData(e?.item, e?.oddsItem, e?.i, e?.bet, e?.oi, e?.bkOrLy, e?.key, this.token);
        this.betSlipData['exposLisDis'] = this.exposLisDis;
        if (data && data?.price) {
            data['event_name'] = this.data?.event?.event?.name;
            this.betSlipModal?.show();
        } else {
            this.betSlipData = {};
        }
    }

    updateEvenByPusher(res: any) {
        if (res.refresh == true) {
            window.location.reload();
        }
        if (res.op == 'UPDATE') {
            if (res.sub_type) {
                if (res.sub_type == 'FANCY_REMOVE') {
                    this.removeMarket(this.data?.event?.fancy, res, 'fancy');
                } else if (res.sub_type == 'FANCY_ADD') {
                    this.addMarket(this.data?.event?.fancy, res, 'fancy');
                } else if (res.sub_type == 'BOOKMAKER_REMOVE') {
                    this.removeMarket(this.data?.event?.book_makers, res, 'bookmaker');
                } else if (res.sub_type == 'BOOKMAKER_ADD') {
                    this.addMarket(this.data?.event?.book_makers, res, 'bookmaker');
                } else if (res.sub_type == 'MARKET_REMOVE') {
                    this.removeMarket(this.data?.event?.markets, res, 'market');
                } else if (res.sub_type == 'MARKET_ADD') {
                    this.addMarket(this.data?.event?.markets, res, 'market');
                } else {
                    // if subtype not FANCY_ADD found
                    console.log("// if subtype not FANCY_ADD found");

                    if (this.isLogin()) {
                        this.getEventDetailOnly();
                    }
                }
            } else {
                // if subtype not found
                console.log("// if subtype not found");
                if (this.isLogin()) {
                    this.getEventDetailOnly();
                }
            }
        }

    }

    addMarket(market: any, res: any, key: string) {
        if (res.m_id) {
            if (res.m_data) {
                // check if marketType (fancy, bookmaker, markets) is not null
                if (market != null) {
                    // if market_id is not in marketIds then add and push to marketType (fancy, bookmaker, markets)
                    if (this.marketIds.indexOf(res.m_id) === -1) {
                        this.marketIds.push(res.m_id)
                        market.push(res.m_data);
                        this.marketsReq = this._common.createMarketIdList(this.data.event) as any;

                        if (key == 'fancy') {
                            if (this.allFancy.indexOf(res.m_data.sort_priority) === -1) {
                                this.allFancy.push(res.m_data.sort_priority);
                            }
                            market.sort((a: any, b: any) => { return a?.sort_priority - b?.sort_priority })
                        }
                    }
                } else {
                    // if no marketType (fancy, bookmaker, markets) found
                    console.log(`// if no ${key} found`);
                    if (this.isLogin()) {
                        this.getEventDetailOnly();
                    }
                }
            } else {
                // if no add marketType (fancy, bookmaker, markets) data found
                console.log(`// if no add ${key} data found`);

                if (this.isLogin()) {
                    this.getEventDetailOnly();
                }
            }
        } else {
            // if no market id found
            console.log("// if no market id found");

            if (this.isLogin()) {
                this.getEventDetailOnly();
            }
        }
    }

    removeMarket(market: any, res: any, key: string) {
        if (res.m_id) {
            if (market != null) {
                let index: any = -1;
                market.forEach((element: any, i: any) => {
                    if (element.market_id == res.m_id) {
                        index = i;
                    }
                });
                // remove marketType (fancy, bookmaker, markets)
                if (index > -1) {
                    market.splice(index, 1);
                    console.log(`remove ${key}` + res.m_id);
                }

                // remove market id
                let market_Type_index = this.marketIds.indexOf(res.m_id);
                if (market_Type_index !== -1) {
                    console.log('removing from active market ' + res.m_id);
                    this.marketIds.splice(market_Type_index, 1);
                }
                this.marketsReq = this._common.createMarketIdList(this.data.event) as any;

            } else {
                // if no marketType (fancy, bookmaker, markets) found
                console.log(`// if no ${key} found`);

                if (this.isLogin()) {
                    this.getEventDetailOnly();
                }
            }
        } else {
            // if no market id found
            console.log("// if no market id found");

            if (this.isLogin()) {
                this.getEventDetailOnly();
            }
        }
    }

    ngDoCheck() {
        if (this.isLogin() && this.userDataGot == false && this.webSocketUrl != '') {
            this.callPusherChannels();
            this.userDataGot = true;
        }
    }

    ngOnDestroy() {
        this.subs.forEach((s) => s.unsubscribe());
        if (this.isLogin() && this._pusher) {
            this._pusher.unsubscribeChannel(`event-${this.actRoute.snapshot.paramMap.get('id')}`);
            this._pusher.unsubscribeChannel(`private-expose.${this.actRoute.snapshot.paramMap.get('id')}.${this.userData.id}`)
        }
    }
}
